import { saveAs } from 'file-saver';
import { getDocumentBuffer } from '../../utils/api';

export const getOneDoc = async (formData, documentId, entityName, accountId, documentLang) => {
  let { docBuffer, docName } = await getDocumentBuffer(formData, documentId, entityName, accountId, documentLang);
  const data = new Uint8Array(docBuffer.data);
  let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
  saveAs(blob, docName + '.docx');
};
